import axios from "../../utils/axios";

// 商品管理
export function getList(query) {
    return axios({
        url: "commodityManage/getList",
        method: "get",
        params: query
    });
}
//商品删除
export function deleteCommodity(data) {
    return axios({
        url: "commodityManage/delete",
        method: "post",
        data: data
    });
}
// 商品增加
export function addCommodity(data) {
    return axios({
        url: "commodityManage/update",
        method: "post",
        data: data
    });
}

// 商品修改
export function updateCommodity(data) {
    return axios({
        url: "commodityManage/update",
        method: "post",
        data: data
    });
}

// 查询一级分类
export function getClassify() {
    return axios({
        url: "/classifyManage/obtainOne",
        method: "get"
    });
}
// 查询二级分类
export function getClassifyTwo(data) {
    return axios({
        url: "/classifyManage/obtainTwoComClassify",
        method: "get",
        params: data
    });
}
// 查询一级场景
export function firstSence() {
    return axios({
        url: "HfSenceMgnt4Back/obtainOneHfSence",
        method: "get"
    });
}
// 查询二级场景
export function secondSence(data) {
    return axios({
        url: "HfSenceMgnt4Back/obtainHfSenceTwoByParentId",
        method: "get",
        params: data
    });
}
//分类联动查询品牌
export function getBrand(data) {
    return axios({
        url: "commodityManage/getComBrand",
        method: "get",
        params: data
    });
}

//查询品牌
export function getBrands(query) {
    return axios({
        url: "commodityManage/getComBrands",
        method: "get",
        params: query
    });
}

//商品上下架
export function upDownCommodity(data) {
    return axios({
        url: "commodityManage/updown",
        method: "get",
        params: data
    });
}

//商品上下架 批量
export function batchUpDownCommodity(data) {
    return axios({
        url: "commodityManage/updownV4",
        method: "get",
        params: data
    });
}

//添加推荐商品查询
export function getAddRecomCommodityList(data) {
    return axios({
        url: "commodityManage/getAddRecomCommodity",
        method: "get",
        params: data
    });
}

//添加推荐商品
export function addRecomCommodity(data) {
    return axios({
        url: "commodityManage/addRecomCommodity",
        method: "get",
        params: data
    });
}

//编辑查看商品
export function CommodityInfo(data) {
    return axios({
        url: "commodityManage/getInfo",
        method: "get",
        params: data
    });
}

//查看商品 4期
export function getCommodityInfo(data) {
    return axios({
        url: "commodityManage/getInfoV4",
        method: "get",
        params: data
    });
}

//查看已推荐的商品
export function getAlreadyRecomCommodity(data) {
    return axios({
        url: "commodityManage/getAlreadyRecomCommodity",
        method: "get",
        params: data
    });
}
//查看可推荐的商品
export function getCanRecomCommodity(data) {
    return axios({
        url: "commodityManage/getCanRecomCommodity",
        method: "get",
        params: data
    });
}
//添加推荐的商品
export function addRecomCommoditys(data) {
    return axios({
        url: "commodityManage/addRecomCommoditys",
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}
//移除推荐的商品
export function removeRecomCommoditys(data) {
    return axios({
        url: "commodityManage/removeRecomCommoditys",
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}
//根据二级分类查询该分类下搜索项
export function getSerchItem(data) {
    return axios({
        url: "commodityManage/obtainHfSerchItemByClassify",
        method: "get",
        params: data
    });
}

//根据二级分类查询该分类下场景
export function getSenceItem(data) {
    return axios({
        url: "commodityManage/senceList",
        method: "get",
        params: data
    });
}
//查询二级场景
export function getAllSence(data) {
    return axios({
        url: "/HfSenceMgnt4Back/obtainTwoAll",
        method: "get",
        params: data
    });
}
//查询二级分类
export function getClassifyAll(data) {
    return axios({
        url: "/classifyManage/obtainTwoComClassifyAll",
        method: "get",
        params: data
    });
}
//获取开启的国家列表
export function getmbcountAll() {
    return axios({
        url: "/mbcount/getmbcountAll",
        method: "get"
    });
}

//商品复制
export function copyCommodity(id) {
    return axios({
        url: "/commodityManage/copy",
        method: "post",
        params: id
    });
}

//导出商品数据
export function exportVer4(data) {
    return axios({
        url: "/commodityManage/exportVer4",
        method: "get",
        params: data
    });
}

//导出空模板
export function downloadTemplateV4(data) {
    return axios({
        url: "/commodityManage/downloadTemplateV4",
        method: "get",
        params: data
    });
}

